export class AdmitAdV2Tracker
{
    static init()
    {
        window.ADMITAD = window.ADMITAD || {};
        window.ADMITAD.Invoice = window.ADMITAD.Invoice || {};
        window.ADMITAD.Invoice.broker = 'adm';
    }

    static orderThankyouPageView(order, basket, user)
    {
        //if (getCookie('utm_source') !== 'AdmitAd') {
        //    return;
        //}

        const orderedItem = AdmitAdV2Tracker.orderPush(basket);
        window.ADMITAD.Invoice.referencesOrder = window.ADMITAD.Invoice.referencesOrder || [];
        window.ADMITAD.Invoice.referencesOrder.push({
            orderNumber: order.id,
            orderedItem: orderedItem
        });
        window.ADMITAD.Invoice.accountId = user.id;
        window.ADMITAD.Invoice.category = (user.is_new_user_ecommerce) ? '8' : '7';
        if (isDevelopment) {
            console.log({
                'track' : AdmitAdV2Tracker.name,
                'data'  : window.ADMITAD,
                'user'  : user,
                'order' : order
            });
        }
    }

    static orderPush(basket)
    {
        const orderedItem = [];
        basket.forEach((basketItem) => {
            orderedItem.push({
                Product: {
                    productID: basketItem.id,
                    category: basketItem.admitad.tariff_code,
                    price: basketItem.price,
                    priceCurrency: basketItem.currency,
                },
                orderQuantity: basketItem.quantity,
                additionalType: 'sale'
            });
        });

        return orderedItem;
    }
}

let getCookie = (name) => {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};


// WEBPACK FOOTER //
// ./modules/tracker/admitadv2.js